(function () {
  var locale = String(document.documentElement.lang || '').toLowerCase();
  var isEnglishLocale = locale.indexOf('en') === 0;
  var isProductPage = /\/products\/[^/?#]+/.test(window.location.pathname);
  var observer = null;
  var frameId = 0;
  var replacements = [
    ['\u0628\u062f\u0648\u0646 \u062a\u062f\u0628\u064a\u0633', 'No Stapling'],
    ['\u0628\u062f\u0648\u0646 Stapling', 'No Stapling'],
    ['\u0627\u0644\u0625\u062e\u0631\u0627\u062c \u0627\u0644\u0641\u0646\u064a', 'Finishing'],
    ['\u0631\u0648\u0644 \u0628\u0644\u0627\u0633\u062a\u064a\u0643', 'Plastic Coil'],
    ['\u0631\u0648\u0644 \u0628\u0644\u0627\u0633\u062a\u0643', 'Plastic Coil'],
    ['\u0631\u0648\u0644 \u0645\u0639\u062f\u0646', 'Metal Coil'],
    ['\u062a\u062b\u0642\u064a\u0628', 'Hole Punching'],
    ['\u0645\u0644\u0627\u062d\u0638\u0627\u062a', 'Notes'],
    ['\u062a\u062f\u0628\u064a\u0633', 'Stapling'],
    ['\u062a\u064a\u0628', 'Tape'],
  ].sort(function (left, right) {
    return right[0].length - left[0].length;
  });

  if (!isEnglishLocale || !isProductPage) {
    return;
  }

  function escapeRegExp(value) {
    return String(value || '').replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function replaceInString(value) {
    var nextValue = String(value || '');

    replacements.forEach(function (entry) {
      var source = entry[0];
      var target = entry[1];
      var matcher = new RegExp(escapeRegExp(source).replace(/\s+/g, '\\s+'), 'g');

      if (matcher.test(nextValue)) {
        nextValue = nextValue.replace(matcher, target);
      }
    });

    return nextValue;
  }

  function getOptisRoots() {
    var roots = Array.prototype.slice.call(
      document.querySelectorAll(
        '.shopify-app-block[data-block-handle="option-set"], .shopify-app-block .bss-po-option-set, .bss-po-option-set, .bss-po-product-page'
      )
    );

    return roots.filter(function (root, index) {
      return root && roots.indexOf(root) === index;
    });
  }

  function translateTextNodes(root) {
    var walker = document.createTreeWalker(
      root,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode: function (node) {
          var parent = node.parentElement;

          if (!parent || !node.nodeValue || node.nodeValue.trim() === '') {
            return NodeFilter.FILTER_REJECT;
          }

          if (['SCRIPT', 'STYLE', 'NOSCRIPT', 'TEMPLATE'].indexOf(parent.tagName) !== -1) {
            return NodeFilter.FILTER_REJECT;
          }

          return NodeFilter.FILTER_ACCEPT;
        },
      }
    );
    var currentNode = walker.nextNode();

    while (currentNode) {
      var translatedValue = replaceInString(currentNode.nodeValue);

      if (translatedValue !== currentNode.nodeValue) {
        currentNode.nodeValue = translatedValue;
      }

      currentNode = walker.nextNode();
    }
  }

  function translateAttributes(root) {
    root.querySelectorAll('[placeholder], [title], [aria-label]').forEach(function (element) {
      ['placeholder', 'title', 'aria-label'].forEach(function (attributeName) {
        var attributeValue = element.getAttribute(attributeName);

        if (!attributeValue) {
          return;
        }

        var translatedValue = replaceInString(attributeValue);

        if (translatedValue !== attributeValue) {
          element.setAttribute(attributeName, translatedValue);
        }
      });
    });
  }

  function applyTranslations() {
    getOptisRoots().forEach(function (root) {
      translateTextNodes(root);
      translateAttributes(root);
    });
  }

  function scheduleTranslation() {
    if (frameId) {
      return;
    }

    frameId = window.requestAnimationFrame(function () {
      frameId = 0;
      applyTranslations();
    });
  }

  function startObserver() {
    if (observer || !document.body) {
      return;
    }

    observer = new MutationObserver(function (mutations) {
      var shouldTranslate = mutations.some(function (mutation) {
        return (
          mutation.type === 'characterData' ||
          (mutation.type === 'childList' && mutation.addedNodes && mutation.addedNodes.length > 0)
        );
      });

      if (shouldTranslate) {
        scheduleTranslation();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  function init() {
    scheduleTranslation();
    startObserver();
    window.setTimeout(scheduleTranslation, 800);
    window.setTimeout(scheduleTranslation, 2000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
    return;
  }

  init();
})();
